"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointsTransactionItemSchema = exports.PointsBalanceItemSchema = exports.getMerchantPointsHistoryResponseSchema = exports.getMerchantPointsHistoryQuerySchema = exports.getMerchantPointsHistoryParamsSchema = exports.getMerchantPointsResponseSchema = exports.getMerchantPointsParamsSchema = exports.listPointsResponseSchema = exports.listPointsQuerySchema = exports.PointsTransactionEntitySchema = exports.UserPointsEntitySchema = exports.PointsTransactionTypeSchema = void 0;
const zod_1 = require("zod");
const common_schemas_1 = require("../base/common.schemas");
const api_schemas_1 = require("../base/api.schemas");
const timestamp_schemas_1 = require("../base/timestamp.schemas");
// ============================================
// INTERNAL SCHEMAS (Entity)
// ============================================
// Points transaction types (from points_transactions.transaction_type CHECK constraint)
const _PointsTransactionTypeSchema = zod_1.z.enum([
    'earned_sharing',
    'earned_redemption',
    'earned_deposit',
    'spent_redemption',
    'adjustment',
    'commission_pending',
    'commission_confirmed',
    'commission_cancelled',
]);
// User points entity schema matching database user_points table
const _UserPointsBaseSchema = zod_1.z.object({
    user_points_id: zod_1.z.number().int().positive(),
    user_id: common_schemas_1.uuidSchema,
    merchant_id: zod_1.z.number().int().positive(),
    points_balance: zod_1.z.number().int().min(0),
    total_earned: zod_1.z.number().int().min(0),
    total_spent: zod_1.z.number().int().min(0),
    pending_points: zod_1.z.number().int().min(0),
    last_updated_at: timestamp_schemas_1.timestampIsoSchema,
});
// Points transaction entity schema matching database points_transactions table
const _PointsTransactionBaseSchema = zod_1.z.object({
    transaction_id: zod_1.z.number().int().positive(),
    user_id: common_schemas_1.uuidSchema,
    merchant_id: zod_1.z.number().int().positive(),
    points_amount: zod_1.z.number().int(), // Positive or negative
    transaction_type: _PointsTransactionTypeSchema,
    balance_after: zod_1.z.number().int(),
    related_coupon_id: zod_1.z.number().int().positive().nullable(),
    related_redemption_id: zod_1.z.number().int().positive().nullable(),
    related_sharing_id: zod_1.z.number().int().positive().nullable(),
    description: zod_1.z.string(),
    created_at: timestamp_schemas_1.timestampIsoSchema,
});
// ============================================
// ENTITY SCHEMAS (Export Aliases)
// ============================================
exports.PointsTransactionTypeSchema = _PointsTransactionTypeSchema;
exports.UserPointsEntitySchema = _UserPointsBaseSchema;
exports.PointsTransactionEntitySchema = _PointsTransactionBaseSchema;
// ============================================
// CUSTOMER POINTS API SCHEMAS
// ============================================
// Internal: Points balance item (per merchant)
const _PointsBalanceItemSchema = zod_1.z.object({
    merchant_id: zod_1.z.number().int(),
    merchant_name: zod_1.z.string(),
    logo_url: zod_1.z.string().url().nullable(),
    available_points: zod_1.z.number().int().min(0), // Ready to redeem
    pending_points: zod_1.z.number().int().min(0), // V1: always 0 (immediate commission). V2: within 3-hour hold period (FR81)
});
// Internal: Points transaction item
const _PointsTransactionItemSchema = zod_1.z.object({
    transaction_id: zod_1.z.number().int(),
    type: _PointsTransactionTypeSchema,
    amount: zod_1.z.number().int(), // Positive for earned, negative for redeemed/cancelled
    description: zod_1.z.string(),
    created_at: timestamp_schemas_1.timestampIsoSchema,
});
// GET /points - Query
exports.listPointsQuerySchema = zod_1.z.object({
    merchantId: zod_1.z.coerce.number().int().positive().optional(), // Filter by merchant
});
// GET /points - Response
exports.listPointsResponseSchema = (0, api_schemas_1.listResponseSchema)(_PointsBalanceItemSchema);
// GET /points/:merchantId - Params
exports.getMerchantPointsParamsSchema = zod_1.z.object({
    merchantId: zod_1.z.coerce.number().int().positive(),
});
// GET /points/:merchantId - Response
exports.getMerchantPointsResponseSchema = (0, api_schemas_1.dataResponseSchema)(_PointsBalanceItemSchema);
// GET /points/:merchantId/history - Params
exports.getMerchantPointsHistoryParamsSchema = zod_1.z.object({
    merchantId: zod_1.z.coerce.number().int().positive(),
});
// GET /points/:merchantId/history - Query
exports.getMerchantPointsHistoryQuerySchema = zod_1.z.object({
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(50),
    cursor: zod_1.z.string().optional(),
});
// GET /points/:merchantId/history - Response
exports.getMerchantPointsHistoryResponseSchema = (0, api_schemas_1.listResponseSchema)(_PointsTransactionItemSchema);
// Export for reuse (API-level schemas)
exports.PointsBalanceItemSchema = _PointsBalanceItemSchema;
exports.PointsTransactionItemSchema = _PointsTransactionItemSchema;
